<section class="app-dialog tickets-reporte-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div class="tickets-reporte-icono" aria-hidden="true">
        <mat-icon>summarize</mat-icon>
      </div>

      <div>
        <p class="app-dialog__eyebrow">Tickets</p>
        <h2 id="tickets-reporte-titulo">Reporte de tickets</h2>
        <p id="tickets-reporte-ayuda">
          Elige el periodo y los filtros. Se toma la fecha en que se abrió cada ticket.
        </p>
      </div>
    </div>

    <button
      type="button"
      mat-icon-button
      class="app-dialog__close"
      aria-label="Cerrar reporte de tickets"
      [disabled]="generando"
      (click)="cerrar()">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </header>

  <form
    class="tickets-reporte-dialog__form"
    [formGroup]="form"
    (ngSubmit)="descargar()"
    novalidate
    autocomplete="off">
    <div mat-dialog-content class="app-dialog__content tickets-reporte-dialog__content">
      @if (errorCatalogos) {
        <div class="tickets-reporte-aviso tickets-reporte-aviso--error" role="alert">
          <mat-icon aria-hidden="true">error_outline</mat-icon>
          <div class="tickets-reporte-aviso__texto">
            <strong>No se pudieron cargar las áreas, los estatus y las empresas.</strong>
            <span>Sin ellos no se puede armar el reporte.</span>
          </div>
          <button
            type="button"
            class="app-form-btn app-form-btn--secondary app-form-btn--compact tickets-reporte-aviso__accion"
            (click)="cargarCatalogos()">
            <mat-icon aria-hidden="true">refresh</mat-icon>
            Reintentar
          </button>
        </div>
      }

      <div class="tickets-reporte-dialog__grid">
        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Área</mat-label>
          <mat-select formControlName="area">
            <mat-option [value]="0">Todas</mat-option>
            @for (area of areas; track area.id) {
              <mat-option [value]="area.id">{{ area.area }}</mat-option>
            }
          </mat-select>
          @if (cargandoCatalogos) {
            <mat-hint>Cargando…</mat-hint>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="table-page__field">
          <mat-label>Estatus</mat-label>
          <mat-select formControlName="estatus">
            <mat-option [value]="0">Todos</mat-option>
            @for (item of estatus; track item.id) {
              <mat-option [value]="item.id">{{ item.nombre }}</mat-option>
            }
          </mat-select>
          @if (cargandoCatalogos) {
            <mat-hint>Cargando…</mat-hint>
          }
        </mat-form-field>

        @if (hayVariasEmpresas) {
          <mat-form-field appearance="outline" class="table-page__field tickets-reporte-dialog__ancho">
            <mat-label>Empresa solicitante</mat-label>
            <mat-select formControlName="empresa">
              <mat-option [value]="0">Todas</mat-option>
              @for (empresa of empresas; track empresa.id) {
                <mat-option [value]="empresa.id">{{ empresa.razon_social }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field appearance="outline" class="table-page__field tickets-reporte-dialog__ancho">
          <mat-label>Periodo</mat-label>
          <mat-date-range-input formGroupName="rango" [rangePicker]="calendario" [min]="minimo" [max]="hoy">
            <input matStartDate formControlName="inicio" placeholder="Desde" aria-label="Desde" />
            <input matEndDate formControlName="fin" placeholder="Hasta" aria-label="Hasta" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="calendario"></mat-datepicker-toggle>
          <mat-date-range-picker #calendario [touchUi]="touchUi"></mat-date-range-picker>
          <mat-hint>dd/mm/aaaa</mat-hint>
          <mat-error>{{ errorPeriodo() }}</mat-error>
        </mat-form-field>

        <mat-chip-listbox
          class="tickets-reporte-dialog__periodos tickets-reporte-dialog__ancho"
          aria-label="Periodos rápidos"
          [formControl]="periodo">
          @for (opcion of periodos; track opcion.id) {
            <mat-chip-option class="tickets-reporte-dialog__chip" [value]="opcion.id">
              {{ opcion.etiqueta }}
            </mat-chip-option>
          }
        </mat-chip-listbox>
      </div>

      <output class="tickets-reporte-dialog__resultado" aria-live="polite">
        @if (resultado === "vacio") {
          <div class="tickets-reporte-aviso tickets-reporte-aviso--vacio">
            <mat-icon aria-hidden="true">search_off</mat-icon>
            <div class="tickets-reporte-aviso__texto">
              <strong>Sin tickets para estos filtros.</strong>
              <span>{{ resumenVacio }}</span>
              <span>{{ sugerenciaVacio }}</span>
            </div>
          </div>
        }
        @if (resultado === "exito") {
          <div class="tickets-reporte-aviso tickets-reporte-aviso--exito">
            <mat-icon aria-hidden="true">task_alt</mat-icon>
            <div class="tickets-reporte-aviso__texto">
              <strong>Se descargó el reporte.</strong>
            </div>
          </div>
        }
      </output>

      @if (resultado === "error") {
        <div class="tickets-reporte-aviso tickets-reporte-aviso--error" role="alert">
          <mat-icon aria-hidden="true">error_outline</mat-icon>
          <div class="tickets-reporte-aviso__texto">
            <strong>No se pudo generar el reporte.</strong>
            @if (detalleError) {
              <span>{{ detalleError }}</span>
            }
          </div>
        </div>
      }
    </div>

    <footer mat-dialog-actions align="end" class="app-dialog__footer tickets-reporte-dialog__footer">
      <button
        type="button"
        class="app-form-btn app-form-btn--secondary app-form-btn--compact tickets-reporte-dialog__limpiar"
        [disabled]="generando"
        (click)="limpiar()">
        <mat-icon aria-hidden="true">filter_alt_off</mat-icon>
        Limpiar
      </button>
      <button
        type="button"
        class="app-form-btn app-form-btn--secondary app-form-btn--compact"
        [disabled]="generando"
        (click)="cerrar()">
        Cancelar
      </button>
      <button
        type="button"
        class="app-form-btn app-form-btn--secondary app-form-btn--compact tickets-reporte-dialog__ancho-movil"
        [disabled]="!puedeGenerar"
        (click)="verVistaPrevia()">
        <mat-icon aria-hidden="true">visibility</mat-icon>
        Vista previa
      </button>
      <button
        #botonDescargar
        type="submit"
        class="app-form-btn app-form-btn--primary app-form-btn--compact tickets-reporte-dialog__ancho-movil"
        [disabled]="!puedeGenerar">
        <mat-icon aria-hidden="true">{{ generando ? "hourglass_top" : "download" }}</mat-icon>
        {{ generando ? "Generando…" : "Descargar Excel" }}
      </button>
    </footer>
  </form>
</section>
